/* BiteClutch — BUY MORE, SAVE MORE (auto tiered discounts) v3 — render NGAY khi giỏ đổi */
(function () {
  if (window.__biteTiersInstalled) return;
  window.__biteTiersInstalled = true;
  if (document.getElementById('bite-tiers-css')) { install(); return; }
  var CSS = [
    '#bite-tierbar{max-width:100%;margin:0 0 6px;padding:12px 14px;background:linear-gradient(135deg,#0b3a5c,#0ea5e9);border-radius:14px;color:#fff;font-family:inherit;font-size:13px;line-height:1.35}',
    '#bite-tierbar *{box-sizing:border-box}',
    '#bite-tierbar__head{display:flex;align-items:center;justify-content:space-between;gap:8px;font-weight:800;font-size:14px;margin-bottom:8px}',
    '#bite-tierbar .tbar-title{letter-spacing:.01em}',
    '#bite-tierbar .tbar-save{background:#ff6b35;color:#fff;font-size:11px;font-weight:800;padding:3px 9px;border-radius:99px;white-space:nowrap}',
    '#bite-tierbar .tbar-tiers{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-bottom:9px}',
    '#bite-tierbar .tier{background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.22);border-radius:9px;padding:5px 3px 6px;text-align:center;transition:all .2s}',
    '#bite-tierbar .tier .t-icon{font-size:13px;display:block;line-height:1}',
    '#bite-tierbar .tier .t-name{display:block;font-size:9px;font-weight:800;letter-spacing:.04em;opacity:.9;margin-top:2px}',
    '#bite-tierbar .tier .t-pct{display:block;font-size:14px;font-weight:800;margin-top:1px}',
    '#bite-tierbar .tier .t-at{display:block;font-size:9px;opacity:.85;margin-top:1px}',
    '#bite-tierbar .tier.t-on{background:rgba(16,185,129,.30);border-color:#34d399;box-shadow:0 0 0 1px #34d399}',
    '#bite-tierbar .tier.t-on .t-name{color:#a7f3d0}',
    '#bite-tierbar .tier.t-next{background:rgba(255,107,53,.30);border-color:#ff6b35;box-shadow:0 0 8px rgba(255,107,53,.5)}',
    '#bite-tierbar .tier.t-next .t-name{color:#ffd166}',
    '#bite-tierbar .tier .t-best{display:block;font-size:8px;font-weight:800;color:#ffd166;letter-spacing:.02em;margin-top:2px}',
    '#bite-tierbar .tier-check{display:block;font-size:9px;line-height:1}',
    '#bite-tierbar .tbar-msg{font-size:13px;font-weight:700;margin-bottom:6px}',
    '#bite-tierbar .tbar-msg .m-strong{color:#ffd166;font-weight:800}',
    '#bite-tierbar .tbar-bar{height:9px;background:rgba(255,255,255,.16);border-radius:99px;overflow:hidden;margin-bottom:4px}',
    '#bite-tierbar .tbar-fill{height:100%;background:linear-gradient(90deg,#ff6b35,#f59e0b);border-radius:99px;transition:width .5s ease}',
    '#bite-tierbar .tbar-meta{display:flex;justify-content:space-between;font-size:10.5px;opacity:.95;margin-bottom:7px}',
    '#bite-tierbar .tbar-note{font-size:9.5px;opacity:.8;border-top:1px solid rgba(255,255,255,.25);padding-top:7px;line-height:1.4}',
    '#bite-tierbar .tbar-cta-wrap{margin:8px 0 6px}',
    '#bite-tierbar .tbar-cta{display:block;text-align:center;width:100%;padding:9px;border:none;border-radius:9px;background:#ff6b35;color:#fff;font-weight:800;font-size:13px;cursor:pointer;text-decoration:none;transition:transform .15s}',
    '#bite-tierbar .tbar-cta:hover{transform:translateY(-1px)}'
  ].join('');
  var STYLE = document.createElement('style');
  STYLE.id = 'bite-tiers-css';
  STYLE.textContent = CSS;
  document.head.appendChild(STYLE);
  install();

  function money(c) { return '$' + (Math.round(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2 }); }

  function install() {
    var running = false;
    function render() {
      var host = document.getElementById('bite-tierbar');
      if (!host) return;
      if (running) return; running = true;
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // LUÔN dùng items_subtotal_price (tiền hàng GỐC trước giảm) —
          // line_price của Shopify có thể đã trừ auto-discount 5% → tính sai tier
          var total = cart.items_subtotal_price || 0;
          if (!total && cart.items) {
            (cart.items).forEach(function (it) { total += it.line_price || (it.price * it.quantity); });
          }
          total = Math.round(total); // cents
          if (total === 0) { host.innerHTML = ''; host.style.display = 'none'; return; }
          host.style.display = '';
          host.innerHTML = build(total);
        })
        .catch(function () {})
        .then(function () { running = false; });
    }
    render();
    setInterval(render, 2500);
    window.__biteRenderTiers = render;
    // Render NGAY khi giỏ thay đổi (add/change/refresh) — không chờ 2.5s
    ['cart:refresh', 'cartLinesUpdate', 'cartUpdate', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(render, 30); }, true);
    });
    // Bắt thêm khi DOM thay đổi trong drawer/cart (MutationObserver nhẹ)
    try {
      var mo = new MutationObserver(function () {
        clearTimeout(mo._t);
        mo._t = setTimeout(render, 150);
      });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-count'] });
    } catch (e) {}
  }

  function build(total) {
    var TIERS = [
      { pct: 5,  min: 6500,  name: 'STARTER',   icon: '🎣', best: false },
      { pct: 10, min: 13000, name: 'STOCK UP',  icon: '🎣', best: false },
      { pct: 15, min: 26000, name: 'BEST VALUE',icon: '⭐️', best: true },
      { pct: 20, min: 39000, name: 'BIG CATCH', icon: '🔥', best: false }
    ];
    var cur = null, next = null;
    TIERS.forEach(function (t) { if (total >= t.min) cur = t; });
    var idx = TIERS.indexOf(cur);
    if (idx >= 0 && idx < TIERS.length - 1) next = TIERS[idx + 1];

    // pills
    var pills = TIERS.map(function (t, i) {
      var on = cur && t.min <= cur.min;
      var isNext = next && t === next;
      var check = on ? '<span class="tier-check">✓</span>' : '';
      var best = t.best ? '<span class="t-best">⭐ BEST VALUE</span>' : '';
      var cls = 'tier' + (on ? ' t-on' : '') + (isNext ? ' t-next' : '');
      return '<div class="' + cls + '">' + check + '<span class="t-icon">' + t.icon + '</span><span class="t-name">' + t.name + '</span><span class="t-pct">' + t.pct + '%</span><span class="t-at">$' + (t.min / 100) + '+</span>' + best + '</div>';
    }).join('');

    var msg, barW, meta, cta;
    if (total >= 39000) {
      msg = '🔥 <span class="m-strong">20% OFF MAX SAVINGS</span> applied at checkout!';
      barW = 100; meta = money(total) + ' / $390+';
      cta = '';
    } else if (next && total >= next.min - 1000 && next.pct === 15) {
      var need = next.min - total;
      msg = '🔥 Only <span class="m-strong">' + money(need) + '</span> away from <span class="m-strong">15% OFF</span>!';
      barW = Math.min(100, Math.round(total / next.min * 100));
      meta = money(total) + ' / $260'; cta = ctaBtn(need, next.pct);
    } else if (next) {
      var needN = next.min - total;
      var atPct = total >= 26000 ? 15 : total >= 13000 ? 10 : total >= 6500 ? 5 : 0;
      if (atPct > 0) {
        msg = '🎣 <span class="m-strong">' + atPct + '% OFF</span> applied now — add <span class="m-strong">' + money(needN) + '</span> more to unlock <span class="m-strong">' + next.pct + '% OFF</span>!';
      } else {
        msg = '🎣 You\'re <span class="m-strong">' + money(needN) + '</span> away from <span class="m-strong">' + next.pct + '% OFF</span>!';
      }
      barW = Math.min(100, Math.round(total / next.min * 100));
      meta = money(total) + ' / $' + (next.min / 100);
      cta = total >= next.min - 3000 ? ctaBtn(needN, next.pct) : '';
    } else {
      // below first tier
      var need0 = TIERS[0].min - total;
      msg = '🎣 Add <span class="m-strong">' + money(need0) + '</span> to unlock <span class="m-strong">5% OFF</span>';
      barW = Math.min(100, Math.round(total / TIERS[0].min * 100));
      meta = money(total) + ' / $65'; cta = ctaBtn(need0, 5);
    }

    return '' +
      '<div class="bite-tierbar__head"><span class="tbar-title">BUY MORE, SAVE MORE 🎣</span><span class="tbar-save">' + saveLabel(total) + '</span></div>' +
      '<div class="tbar-tiers">' + pills + '</div>' +
      '<div class="tbar-msg">' + msg + '</div>' +
      '<div class="tbar-bar"><div class="tbar-fill" style="width:' + barW + '%"></div></div>' +
      '<div class="tbar-meta"><span>' + meta + '</span><span>' + (next ? next.pct + '% OFF' : (total >= 39000 ? '20% OFF' : '5% OFF')) + '</span></div>' +
      (cta ? '<div class="tbar-cta-wrap">' + cta + '</div>' : '') +
      '<div class="tbar-note">Discount applies automatically to this order based on subtotal. Tiers cannot be combined across multiple orders.</div>';
  }

  function ctaBtn(need, pct) {
    var needD = (Math.round(need) / 100);
    return '<a class="tbar-cta" href="/collections/tackle-and-accessories">Add ' + money(need) + ' more → unlock ' + pct + '% OFF</a>';
  }

  function saveLabel(total) {
    if (total >= 39000) return 'SAVE 20%';
    if (total >= 26000) return 'SAVE 15%';
    if (total >= 13000) return 'SAVE 10%';
    if (total >= 6500) return 'SAVE 5%';
    return 'BUY MORE';
  }
})();
